import React from 'react'
import { H3 } from 'components/Heading'
import { formatPrice } from 'services/plans'

/**
 * The share FAQ component
 * @param {Map} props.staticText - The static text
 * @param {Map} props.offerPlan - The biling plan data
 * @returns {JSX.Element} FAQ component
 */
function SharePageV3Faq (props) {
  const { staticText, offerPlan, language } = props

  const currencyIso = offerPlan.get('currencyIso')
  const monthlyPriceVal = offerPlan.getIn(['costs', '1'], '0')
  const monthlyPrice = formatPrice(currencyIso, monthlyPriceVal, false, null, language)

  return (
    <div className="share-page-v3__faq">
      <H3 className="share-page-v3__faq-title">{staticText.get('faqTitle')}</H3>
      <div className="share-page-v3__faq-list">
        <div className="share-page-v3__faq-item">
          <p className="share-page-v3__faq-item-title">{staticText.get('faqItem1Title')}</p>
          <p className="share-page-v3__faq-item-text">{staticText.get('faqItem1Text')}</p>
        </div>
        <div className="share-page-v3__faq-item">
          <p className="share-page-v3__faq-item-title">{staticText.get('faqItem2Title')}</p>
          <p className="share-page-v3__faq-item-text">{staticText.get('faqItem2Text')}</p>
        </div>
        <div className="share-page-v3__faq-item">
          <p className="share-page-v3__faq-item-title">{staticText.get('faqItem3Title')}</p>
          <p className="share-page-v3__faq-item-text">
            {staticText.get('faqItem3Text', '').replace(/\$\{ price \}/, monthlyPrice)}
            </p>
        </div>
        <div className="share-page-v3__faq-item">
          <p className="share-page-v3__faq-item-title">{staticText.get('faqItem4Title')}</p>
          <p className="share-page-v3__faq-item-text">{staticText.get('faqItem4Text')}</p>
        </div>
        <div className="share-page-v3__faq-item">
          <p className="share-page-v3__faq-item-title">{staticText.get('faqItem5Title')}</p>
          <p className="share-page-v3__faq-item-text">{staticText.get('faqItem5Text')}</p>
        </div>
        <div className="share-page-v3__faq-item">
          <p className="share-page-v3__faq-item-title">{staticText.get('faqItem6Title')}</p>
          <p className="share-page-v3__faq-item-text">{staticText.get('faqItem6Text')}</p>
        </div>
      </div>
    </div>
  )
}

export default SharePageV3Faq
